import React from 'react';
import './Lab.css'; 
import image1 from "./IMAGE/WhatsApp Image 2025-02-24 at 18.23.15.jpeg";
import image2 from "./IMAGE/WhatsApp Image 2025-02-24 at 18.05.10.jpeg";
import image3 from "./IMAGE/WhatsApp Image 2025-02-24 at 18.14.54.jpeg";
import image4 from "./IMAGE/WhatsApp Image 2025-02-24 at 18.24.12.jpeg";

const Lab = () => {
  const experiments = [
    {
      title: "Study of local anaesthetics on rabbit eye",
      image: image1, 
      details: [
        "Objective: To study the effect of local anaesthetics on rabbit eye by observing corneal reflex suppression.",
        "Procedure: Administer the local anaesthetic drop to one eye and observe reflex changes using a cotton thread.",
        "Observation: Compare the response with the untreated eye and document the duration of anaesthesia."
      ]
    },
    {
      title: "Study of analgesic activity by writhing test",
      image: image2, 
      details: [
        "Objective: To evaluate the analgesic effect of a drug by inducing abdominal constrictions (writhes) in mice.",
        "Procedure: Inject acetic acid intraperitoneally to induce writhing and administer the test drug.",
        "Observation: Count the number of writhes in treated and control groups to assess analgesic efficacy."
      ]
    },
    {
      title: "Screening of CNS stimulants and depressants using Actophotometer",
      image: image3, 
      details: [
        "Objective: To measure the locomotor activity changes due to CNS stimulants and depressants.",
        "Procedure: Place the animal in an actophotometer and record basal activity, then administer the drug and re-measure activity.",
        "Observation: Compare activity count before and after drug administration to determine CNS effect."
      ]
    },
    {
      title: "Pyrogen testing by rabbit method",
      image: image4, 
      details: [
        "Objective: To detect the presence of pyrogens in a pharmaceutical sample using rabbits.",
        "Procedure: Inject the test sample intravenously into rabbits and monitor body temperature at regular intervals.",
        "Observation: Any significant rise in temperature indicates the presence of pyrogens in the sample."
      ]
    }
  ];

  return (
    <div className="lab-container">
      <h1 className="lab-header">Lab Experiments</h1>
      <div className="lab-cards-container">
        {experiments.map((experiment, index) => (
          <div key={index} className="lab-card">
            <img src={experiment.image} alt={experiment.title} className="lab-image" style={{ width: '100%', height: '400px' }} />
            <h2 className="lab-title">{experiment.title}</h2>
            <ul className="lab-details">
              {experiment.details.map((detail, idx) => (
                <li key={idx}>{detail}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Lab;
